import React from "react";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import WhatsAppFloat from "@/components/sections/WhatsAppFloat";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Clock, FileCheck, MessageCircle, ArrowRight } from "lucide-react";
import { useLeadDialog } from "@/components/sections/LeadDialog";

export default function Evaluacion() {
  const { open } = useLeadDialog();
  const openWA = () => open("evaluacion");

  return (
    <div className="min-h-screen bg-white" data-testid="evaluacion-page">
      <Header onCtaClick={openWA} />
      <main>
        <section className="bg-gradient-to-b from-slate-50 to-white py-16 lg:py-24 border-b border-slate-200">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
              Evaluación de crédito
            </span>
            <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
              Solicita tu evaluación
              <span className="block text-blue-600">gratuita y sin compromiso</span>
            </h1>
            <p className="mt-6 max-w-2xl text-lg text-slate-600 leading-relaxed">
              Completa un formulario rápido y serás redirigido automáticamente
              a WhatsApp para continuar con un asesor. Recuerda: Bancoorp es
              intermediario; la decisión final la toma la entidad financiera.
            </p>

            <div className="mt-8 grid sm:grid-cols-3 gap-4 max-w-3xl">
              <div className="flex items-center gap-2 text-sm text-slate-600">
                <ShieldCheck className="h-4 w-4 text-teal-500" /> 100% confidencial
              </div>
              <div className="flex items-center gap-2 text-sm text-slate-600">
                <Clock className="h-4 w-4 text-teal-500" /> Menos de 1 minuto
              </div>
              <div className="flex items-center gap-2 text-sm text-slate-600">
                <FileCheck className="h-4 w-4 text-teal-500" /> Sin costo
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 lg:py-24">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-8 sm:p-12 text-center">
              <div className="mx-auto h-14 w-14 rounded-2xl bg-blue-600 text-white flex items-center justify-center">
                <MessageCircle className="h-7 w-7" />
              </div>
              <h2 className="mt-5 text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
                Inicia tu evaluación ahora
              </h2>
              <p className="mt-3 text-slate-600 max-w-lg mx-auto">
                Solo necesitamos cinco datos (nombre, RUT, teléfono, correo y
                monto) para conectarte con un asesor.
              </p>
              <Button
                onClick={openWA}
                size="lg"
                className="mt-7 bg-blue-600 hover:bg-blue-700 text-white rounded-full px-7 py-6 text-base font-semibold"
                data-testid="evaluacion-cta"
              >
                Solicitar evaluación
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
              <p className="mt-5 text-xs text-slate-500">
                Sin costo · Sin compromiso · Datos tratados según Ley N° 19.628
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer onCtaClick={openWA} />
      <WhatsAppFloat />
    </div>
  );
}
